'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');

/**
 * 柱状图
 */
var ColumnChart = React.createClass({

  render: function () {
    var w = styleHelper.getWidth(this.props);
    var chartWidth = Math.round(w / 7);

    var offset = chartWidth;

    var chart1Style = {
      left: offset
    };

    offset = chartWidth * 2 + 6;

    var chart2Style = {
      left: offset
    };

    offset = chartWidth * 4;

    var chart3Style = {
      left: offset
    };

    offset = chartWidth * 5 + 6;
    var chart4Style = {
      left: offset
    };

    return (<div className="content">
      <div className="chart-one" style={chart1Style}/>
      <div className="chart-two" style={chart2Style}/>
      <div className="chart-three" style={chart3Style}/>
      <div className="chart-four" style={chart4Style}/>
    </div>);
  }


});

module.exports = ColumnChart;



// WEBPACK FOOTER //
// ./src/views/Components/ColumnChart.jsx